import { render, staticRenderFns } from "./BookingEditModal.vue?vue&type=template&id=589bb6a9"
import script from "./BookingEditModal.vue?vue&type=script&lang=ts"
export * from "./BookingEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports